import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NotificationService} from '../../../services/notification.service';

@Component({
  selector: 'app-subcategory-picker',
  templateUrl: './subcategory-picker.component.html',
  styleUrls: ['./subcategory-picker.component.scss']

})
export class SubcategoryPickerComponent implements OnInit {

  @Input() categories;
  @Input() enterPressed: EventEmitter<boolean>;
  @Output() subcategoryFound = new EventEmitter<number>();
  selectionCount: number;

  constructor(private notificationService: NotificationService) {
  }

  _search;

  @Input() set search(search: any) {
    this._search = search;
    this.selectionCount = this.countSelection(search).length;
  }

  ngOnInit(): void {
    this.enterPressed.subscribe(() => {
      if (this.selectionCount === 1) {
        this.subcategoryFound.emit(this.countSelection(this._search)[0].id);
      }
    });
  }

  selected(name) {
    return !(this._search == null || this._search === '') &&
      name.toLowerCase().indexOf(this._search.toLowerCase()) !== -1;
  }

  countSelection(search) {
    if (search == null || search === '') {
      return [];
    }
    const selection = [];
    for (const category of this.categories) {
      for (const subcategory of category.value) {
        if (this.selected(subcategory.name)) {
          selection.push(subcategory);
        }
      }
    }
    return selection;
  }

  getNumberOfColumns() {
    let counter = 0, property;
    for (property in this.categories) {
      if (this.categories.hasOwnProperty(property)) {
        counter++;
      }
    }
    return counter;
  }
}
